// قانون‌های فیلدهای سفارشی قالب ژومنت و متن‌های خطای ژومنت، برای همه‌ی فرم‌های ژومنت. خود قانون‌ها (چک‌دیجیت کارت، شبا، آیدی
// اینستاگرام) و متن پیش‌فرضشان در core است (site_helpers)؛ این‌جا فقط کلید فیلدهای سفارشی همین قالب به آن قانون‌ها وصل می‌شود.
// کلید هر قانون همان <key> در custom:<key> است. هر فرم متن‌های خودش را با merge_messages روی SITE_MESSAGES می‌گذارد.
import { IRANIAN_FIELD_RULES } from "@core/helpers/client/form-renderer/site_helpers";

export { merge_messages } from "@core/helpers/client/form-renderer/site_helpers";

// شبا: کم بودن رقم (sheba_length) و شبای نامعتبر (invalid_sheba_number) را core جدا می‌گوید، با متن خودش
export const CUSTOM_RULES = {
	"card-number": IRANIAN_FIELD_RULES.card_number,
	"sheba-number": IRANIAN_FIELD_RULES.sheba_number,
	"instagram-id": IRANIAN_FIELD_RULES.instagram_id,
};

// متن‌هایی که ژومنت جور دیگری از core می‌گوید
export const SITE_MESSAGES = {
	fa: {
		errors: {
			invalid_national_code: "فرمت کد ملی صحیح نیست.",
		},
	},
};
